/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const previewRoutineCreateBodyExpectedVersionExclusiveMin = 0;
export const previewRoutineCreateBodyExpectedVersionMax = 9007199254740991;

export const previewRoutineCreateBodyRoutineStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const previewRoutineCreateBodyRoutineAnchorClockLocalRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const previewRoutineCreateBodyRoutineRotationCountExclusiveMin = 0;
export const previewRoutineCreateBodyRoutineRotationCountMax = 2147483647;

export const previewRoutineCreateBodyRoutineSectionsItemStartWeekdayMax = 7;

export const previewRoutineCreateBodyRoutineSectionsItemStartLocalMinuteMin = 0;
export const previewRoutineCreateBodyRoutineSectionsItemStartLocalMinuteMax = 1439;

export const previewRoutineCreateBodyRoutineSectionsItemEndWeekdayMax = 7;

export const previewRoutineCreateBodyRoutineSectionsItemEndLocalMinuteMin = 0;
export const previewRoutineCreateBodyRoutineSectionsItemEndLocalMinuteMax = 1439;

export const previewRoutineCreateBodyRoutineSectionsItemFullWeekDefault = false;
export const previewRoutineCreateBodyRoutineSectionsMax = 14;

export const previewRoutineCreateBodyRoutineParticipantsItemOrdinalMin = 0;
export const previewRoutineCreateBodyRoutineParticipantsItemOrdinalMax = 19;

export const previewRoutineCreateBodyRoutineParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const previewRoutineCreateBodyRoutineParticipantsMax = 20;

export const previewRoutineCreateBodyRoutineEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const previewRoutineCreateBodyWindowDisplayTimeZoneMax = 100;

export const previewRoutineCreateBodyWindowReferenceDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const previewRoutineCreateBodyWindowRangeDefault = `two-weeks`;
export const PreviewRoutineCreateBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(previewRoutineCreateBodyExpectedVersionExclusiveMin)
    .max(previewRoutineCreateBodyExpectedVersionMax),
  routine: zod.object({
    name: zod.string(),
    startLocalDate: zod.iso.date().regex(previewRoutineCreateBodyRoutineStartLocalDateRegExp),
    anchorClockLocal: zod.string().regex(previewRoutineCreateBodyRoutineAnchorClockLocalRegExp),
    rotation: zod.object({
      unit: zod.enum(['day', 'week']),
      count: zod
        .int()
        .gt(previewRoutineCreateBodyRoutineRotationCountExclusiveMin)
        .max(previewRoutineCreateBodyRoutineRotationCountMax),
    }),
    sections: zod
      .array(
        zod.object({
          startWeekday: zod
            .int()
            .min(1)
            .max(previewRoutineCreateBodyRoutineSectionsItemStartWeekdayMax),
          startLocalMinute: zod
            .int()
            .min(previewRoutineCreateBodyRoutineSectionsItemStartLocalMinuteMin)
            .max(previewRoutineCreateBodyRoutineSectionsItemStartLocalMinuteMax),
          endWeekday: zod
            .int()
            .min(1)
            .max(previewRoutineCreateBodyRoutineSectionsItemEndWeekdayMax),
          endLocalMinute: zod
            .int()
            .min(previewRoutineCreateBodyRoutineSectionsItemEndLocalMinuteMin)
            .max(previewRoutineCreateBodyRoutineSectionsItemEndLocalMinuteMax),
          fullWeek: zod
            .boolean()
            .default(previewRoutineCreateBodyRoutineSectionsItemFullWeekDefault),
        }),
      )
      .min(1)
      .max(previewRoutineCreateBodyRoutineSectionsMax),
    participants: zod
      .array(
        zod.object({
          ordinal: zod
            .int()
            .min(previewRoutineCreateBodyRoutineParticipantsItemOrdinalMin)
            .max(previewRoutineCreateBodyRoutineParticipantsItemOrdinalMax),
          userId: zod.uuid().regex(previewRoutineCreateBodyRoutineParticipantsItemUserIdRegExp),
        }),
      )
      .min(1)
      .max(previewRoutineCreateBodyRoutineParticipantsMax),
    endedAt: zod
      .union([
        zod.iso.datetime({ offset: true }).regex(previewRoutineCreateBodyRoutineEndedAtOneRegExp),
        zod.null(),
      ])
      .optional(),
  }),
  window: zod.object({
    displayTimeZone: zod.string().min(1).max(previewRoutineCreateBodyWindowDisplayTimeZoneMax),
    referenceDate: zod.iso.date().regex(previewRoutineCreateBodyWindowReferenceDateRegExp),
    range: zod
      .enum(['one-day', 'one-week', 'two-weeks', 'one-month'])
      .default(previewRoutineCreateBodyWindowRangeDefault),
  }),
});

export type PreviewRoutineCreateBody = zod.input<typeof PreviewRoutineCreateBody>;
export type PreviewRoutineCreateBodyOutput = zod.output<typeof PreviewRoutineCreateBody>;
